<template>
  <div class="mt-2">
    <fcc-table
      striped
      hover
      responsive
      :items="dificuldades"
      :fields="fields"
      :optionsButton="options"
      :actions="actions"
      pagination
    />

    <fccModal
      idModal="modal-dificuldade"
      :titleModal="titleModal"
      centered
      escondeFooter
      travaEsc
      travaBack
      @close="limparForm"
    >
      <b-form @submit.prevent="salvar" autocomplete="off"
        ><div class="row mb-4">
          <div class="col"><fcc-input v-model="form.descricao" required>Descrição</fcc-input></div>
        </div>

        <div class="row text-right">
          <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
        </div></b-form
      >
    </fccModal>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import { acaoConstantes } from '../constants'
import axios from 'axios'

export default {
  data() {
    return {
      itemSelecionado: null,
      form: { descricao: '' },
      acaoModal: acaoConstantes.ADICIONAR,
      fields: [
        { key: 'tpdificuldade', label: 'Tp Dificuldade', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      options: [
        {
          funcaoButton: 'adicionar',
          text: 'Adicionar',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['dificuldades']),
    titleModal() {
      return this.acaoModal === acaoConstantes.ADICIONAR
        ? 'Adicionar Dificuldade'
        : 'Editar Dificuldade'
    }
  },
  mounted() {
    this.atualizarItens()
  },
  methods: {
    limparForm() {
      this.form = { descricao: '' }
    },
    atualizarItens() {
      store
        .dispatch(
          'acompanhamentoDeProjetos/fetchDificuldades',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => this.$emit('carregado'))
        .catch(this.setErrorSystem)
    },
    adicionar() {
      this.acaoModal = acaoConstantes.ADICIONAR
      this.$root.$emit('bv::show::modal', 'modal-dificuldade')
    },
    salvar() {
      this.callConfirm(
        this.acaoModal === acaoConstantes.ADICIONAR
          ? 'Deseja adicionar uma dificuldade?'
          : 'Deseja editar a dificuldade?',
        ''
      ).then((result) => {
        if (result.value) {
          const methodTipoSistema =
            this.acaoModal === acaoConstantes.ADICIONAR
              ? this.dificuldadeAdicionar
              : this.dificuldadeAlterar

          this.carregaTexto(this.codeMensagem('C01'))
          methodTipoSistema()
            .then(() => {
              this.carregaTexto()
              this.limparForm()
              this.atualizarItens()
              this.$root.$emit('bv::hide::modal', 'modal-dificuldade')
              this.acaoModal === acaoConstantes.ADICIONAR
                ? this.callToast(this.mensagensUpdate.adicionado)
                : this.callToast(this.mensagensUpdate.editado, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    dificuldadeAdicionar() {
      const payload = {
        tpDificuldade: 0,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.post(
        store.state.baseUrlGestaoProjetos + 'TipoDificuldade/Adicionar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    dificuldadeAlterar() {
      const payload = {
        tpDificuldade: this.itemSelecionado.tpdificuldade,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.put(
        store.state.baseUrlGestaoProjetos + 'TipoDificuldade/Alterar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    dificuldadeExcluir(idDificuldade) {
      return axios.delete(
        store.state.baseUrlGestaoProjetos + 'TipoDificuldade/Excluir/' + idDificuldade,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    editField(_, item) {
      this.itemSelecionado = item
      this.form.descricao = item.descricao
      this.acaoModal = acaoConstantes.EDITAR
      this.$root.$emit('bv::show::modal', 'modal-dificuldade')
    },
    deleteField(_, item) {
      this.callConfirm('Deseja excluir a dificuldade?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.dificuldadeExcluir(item.tpdificuldade)
            .then(() => {
              this.carregaTexto()
              this.atualizarItens()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    }
  }
}
</script>